<template>
  <div id="surgeryList">

    <vx-card
      v-for="(item, index) in data"
      :key="item.ID || item.id || index"
      class="mb-base"
    >

      <div class="vx-row lg:px-24 md:px-20 sm:px-12 px-6">

        <!-- ========================= -->
        <!-- Hospital Information -->
        <!-- ========================= -->
        <div class="vx-col lg:w-2/3 w-full">

          <imageLazy
            :imageStyle="{
              'border-radius': '20px',
              'height': '18vh'
            }"
            :imageClass="'w-full'"
            :src="baseURL + item.ImagePath"
            placeHolderType="hospital"
            @click="goToHospital(item)"
          />

          <!-- Hospital Name -->
          <h2
            class="font-bold mt-3 greenColor"
            style="
              cursor: pointer;
              text-decoration: underline;
            "
            @click="goToHospital(item)"
          >
            {{ item.Name }}
          </h2>


          <!-- ========================= -->
          <!-- Google Rating -->
          <!-- ========================= -->
          <div class="google-rating-wrapper mt-2 mb-2">

            <div
              v-if="hasGoogleRating(item)"
              class="google-rating-row"
            >

              <h5
                class="google-rating-title"
              >
                Google Rating:
              </h5>

              <!-- Numeric Rating -->
              <strong
                class="google-rating-number greenColor"
              >
                {{ formatGoogleRating(item) }}
              </strong>

              <!-- Stars -->
              <div class="google-stars">
                <rate
                  :rateValue="getGoogleRating(item)"
                />
              </div>

              <!-- Reviews Count -->
              <span
                v-if="getGoogleUserRatingCount(item) !== null"
                class="google-reviews-count"
              >
                ({{ formatReviewCount(
                  getGoogleUserRatingCount(item)
                ) }})
              </span>

              <!-- Google attribution -->
              <span class="google-source">
                Google
              </span>

            </div>


            <!-- No Google Rating -->
            <div
              v-else
              class="google-rating-row"
            >
              <h5
                class="google-rating-title"
              >
                Google Rating:
              </h5>

              <span class="google-rating-unavailable">
                Not available
              </span>
            </div>

          </div>


          <!-- ========================= -->
          <!-- Hospital Info -->
          <!-- ========================= -->
          <p
            class="vx-col hospital-info"
            v-if="item.HospitalInfo"
            v-html="
              item.HospitalInfo.substring(
                0,
                item.numberOfWords === undefined
                  ? 300
                  : item.numberOfWords
              )
            "
          >
          </p>

          <u
            class="show-more"
            v-if="
              item.HospitalInfo &&
              item.numberOfWords === undefined
            "
            @click="updateNumberOfWords(item)"
          >
            {{ $t('ShowMore') }}
          </u>

        </div>


        <!-- ========================= -->
        <!-- Surgery Categories -->
        <!-- ========================= -->
        <div
          class="vx-col lg:w-1/3 w-full mt-10"
        >

          <vs-button
            v-for="(col, categoryIndex)
              in item.SurgeryCategorys"
            :key="
              col.ID ||
              categoryIndex
            "
            class="w-full m-4"
            vs-w="3"
            vs-sm="5"
            @click="
              $emit(
                'getSurgeries',
                col.ID,
                item.ID
              )
            "
          >
            {{ col.Name }}
          </vs-button>

        </div>

      </div>

    </vx-card>

  </div>
</template>


<script>

import { domain } from "@/gloabelConstant.js";
import hospitalSurgeries from "./HospitalSurgeriesPopup.vue";
import imageLazy from "@/components/image_lazy.vue";

export default {

  name: "HospitalSurgeryList",

  components: {
    hospitalSurgeries,
    imageLazy
  },

  props: {

    data: {
      type: Array,

      default: () => []
    }

  },

  data() {

    return {

      baseURL: domain,

      StatusList: [

        {
          Code: 1,
          Value: "Recommended"
        },

        {
          Code: 2,
          Value: "Highest Price"
        },

        {
          Code: 3,
          Value: "Lowest Price"
        },

        {
          Code: 4,
          Value: "Rate"
        }

      ]

    };

  },

  methods: {

    // =========================================
    // Hospital navigation
    // =========================================
    goToHospital(item) {

      const hospitalId =
        item.ID || item.id;

      if (!hospitalId) {
        return;
      }

      this.$router.push(
        "/hospitalprofile/" +
        hospitalId
      );

    },


    // =========================================
    // Support:
    //
    // GoogleRating
    // googleRating
    //
    // depending on JSON serialization
    // =========================================
    getGoogleRating(item) {

      if (!item) {
        return null;
      }

      let rating = null;

      if (
        item.GoogleRating !== undefined &&
        item.GoogleRating !== null
      ) {

        rating =
          item.GoogleRating;

      }
      else if (
        item.googleRating !== undefined &&
        item.googleRating !== null
      ) {

        rating =
          item.googleRating;

      }

      if (
        rating === null ||
        rating === ""
      ) {
        return null;
      }

      const numericRating =
        Number(rating);

      if (isNaN(numericRating)) {
        return null;
      }

      return numericRating;

    },


    // =========================================
    // Has Google Rating
    // =========================================
    hasGoogleRating(item) {

      const rating =
        this.getGoogleRating(item);

      return (
        rating !== null &&
        rating >= 0
      );

    },


    // =========================================
    // Format Rating
    // Example:
    // 4.345 -> 4.3
    // =========================================
    formatGoogleRating(item) {

      const rating =
        this.getGoogleRating(item);

      if (rating === null) {
        return "-";
      }

      return rating.toFixed(1);

    },


    // =========================================
    // Google Reviews Count
    //
    // Support PascalCase / camelCase
    // =========================================
    getGoogleUserRatingCount(item) {

      if (!item) {
        return null;
      }

      let count = null;

      if (
        item.GoogleUserRatingCount !==
          undefined &&
        item.GoogleUserRatingCount !==
          null
      ) {

        count =
          item.GoogleUserRatingCount;

      }
      else if (
        item.googleUserRatingCount !==
          undefined &&
        item.googleUserRatingCount !==
          null
      ) {

        count =
          item.googleUserRatingCount;

      }

      if (
        count === null ||
        count === ""
      ) {
        return null;
      }

      const numericCount =
        Number(count);

      if (isNaN(numericCount)) {
        return null;
      }

      return numericCount;

    },


    // =========================================
    // Format Reviews Count
    // Example:
    // 12500 -> 12,500
    // =========================================
    formatReviewCount(count) {

      if (
        count === null ||
        count === undefined
      ) {
        return "";
      }

      return Number(count)
        .toLocaleString();

    },


    // =========================================
    // Biography
    // =========================================
    viewBiography() {

      this.showBiography =
        !this.showBiography;

    },


    // =========================================
    // Show More
    // =========================================
    updateNumberOfWords(item) {

      this.$set(
        item,
        "numberOfWords",
        200000
      );

    }

  }

};

</script>


<style>

#surgeryList .vx-row {
  margin: unset;
}


/* =============================== */
/* Google Rating */
/* =============================== */

#surgeryList .google-rating-wrapper {
  width: 100%;
}


#surgeryList .google-rating-row {
  display: flex;

  align-items: center;

  flex-wrap: wrap;

  min-height: 32px;
}


#surgeryList .google-rating-title {
  color: #696688;

  margin-right: 10px;

  margin-bottom: 0;
}


#surgeryList .google-rating-number {
  font-size: 18px;

  font-weight: bold;

  margin-right: 8px;
}


#surgeryList .google-stars {
  display: flex;

  align-items: center;
}


#surgeryList .google-reviews-count {
  margin-left: 8px;

  color: #777;

  font-size: 13px;
}


#surgeryList .google-source {
  margin-left: 8px;

  color: #777;

  font-size: 11px;
}


#surgeryList .google-rating-unavailable {
  color: #999;

  font-size: 13px;
}


/* =============================== */
/* Hospital information */
/* =============================== */

#surgeryList .hospital-info {
  margin-top: 10px;
}


#surgeryList .show-more {
  color: #00C524;

  cursor: pointer;
}


/* =============================== */
/* Existing */
/* =============================== */

.doctorImage {
  width: 100px;

  height: 100px;

  text-align: end;
}

</style>